import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import auth from './auth';
import ui from './ui';
import device from './device';
import groups from './groups';
import layers from './layers';
import fences from './fences';
import events from './events';
import report from './report';

const dataPersisted = createPersistedState({
    key: 'ui-settings',
    paths: ['ui', 'report'],
});

export default createStore({
    plugins: [dataPersisted],
    modules: {
        auth,
        ui,
        device,
        groups,
        layers,
        fences,
        events,
        report,
    },
});
